/*
 * @Author: cc
 * @LastEditTime: 2025-08-27 17:47:44
 */
import { Button, Modal } from "antd";
import { memo, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { post } from "../../common/fetch";
import no_class from "../../img/no_class.png";
import "./_style.scss";
import UserOrderConfirm from "./component/pay";
const PremiumCourse = memo((props: { commodityMenuId?: string }) => {
  const history = useHistory();
  const [showUserConfirmModal, setShowUserConfirmModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [courseInfo, setCourseInfo] = useState<any>();
  const [classList, setClassList] = useState<any[]>([]);
  const { commodityMenuId } = props;
  const [commodityId, setCommodityId] = useState(""); // 商品ID
  const [price, setPrice] = useState(0); // 当前订单价格
  const [commodityName, setCommodityName] = useState(""); // 商品名称
  /**
   * 根据类型获取商品列表
   */
  const getCommodityList = () => {
    post(
      `/shop/front/commodity/list`,
      {
        commodity: {
          commodityMenuId,
        },
        page: {
          currentPage: 1,
          pageSize: 1000,
        },
      },
      true
    ).then((res) => {
      const { data } = res;
      setClassList(
        data.commodityList.map((item: any) => ({
          ...item,
          commodityImageUrl: item.titleBackgroundFlag
            ? item.commodityImageAllPath
            : item.originalImageAllPath,
        }))
      );
    });
  };
  useEffect(() => {
    getCommodityList();
  }, []);
  /**
   * 学习
   */
  const learnCourse = (record: any) => {
    // 如果是获取免费课程
    if (
      record.salePrice === 0 &&
      record.commodityUserStatus === 3 &&
      record.commodityUserStatus !== 1
    ) {
      post(`/shop/front/commodity/${record.id}/free/join`, {}, true).then(
        (res) => {
          Modal.info({
            title: "消息",
            content: <p>${res.data.code === 0 ? "操作成功" : "操作失败"}</p>,
            onOk() {
              res.data.code === 0 && window.location.reload();
            },
          });
        }
      );
    } else {
      if (record.commodityType === 2) {
        const url = `/shop/ccLiveFunction/getUserProjectLiveUrl?roomId=${record.liveRoomId}&ccUserId=${record.ccUserId}`;
        window.open(url);
      } else {
        // 如果是专项培训
        if (record.commodityType === 1) {
          history.push(
            `/projectInfo?projectId=${record.resourceId}&projectType=${record.commodityType}`
          );
        } else {
          history.push(
            `/play?courseId=${record.resourceId}&type=platformResource`
          );
        }
      }
    }
  };
  return (
    <div className="platform_train_container">
      {classList.map((item, index) => {
        return (
          <div className="class_box" key={index}>
            <img
              src={item.commodityImageUrl}
              alt=""
              style={{ width: "100%" }}
            />
            <div className="class_title_box">
              <h5>{item.commodityName}</h5>
              <div className="timeRange_box">
                <p className="timeRange">
                  {item.saleTimeLimitRangeLabel &&
                    `报名时间：${item.saleTimeLimitRangeLabel}`}
                </p>
                {item.liveStartTimeStr && (
                  <p className="timeRange">直播时间：{item.liveStartTimeStr}</p>
                )}
              </div>
              <div className="price_box">
                {item.surplusQuantityFlag === 1 ? (
                  <span>剩余：{item.surplusQuantity}</span>
                ) : (
                  <span></span>
                )}
                {/* 非免费 */}
                {item.salePrice !== 0 && item.commodityUserStatus !== 7 && (
                  <h5 className="price">{item.salePriceLabel}</h5>
                )}
                {/* 免费 */}
                {item.salePrice === 0 && item.commodityUserStatus !== 7 && (
                  <h5 style={{ color: "red" }}>免费</h5>
                )}
                {/* 已购买 */}
                {item.commodityUserStatus === 7 && (
                  <h5 style={{ color: "gray" }}>已拥有</h5>
                )}
              </div>
              <div className="btn_group">
                <Button
                  type="primary"
                  onClick={() => {
                    Modal.success({
                      title: "简介",
                      okText: "确定",
                      content: item.introduction,
                    });
                  }}
                >
                  简介
                </Button>
                {/* 已购买 */}
                {item.commodityUserStatus === 7 && (
                  <Button
                    type="primary"
                    onClick={() => {
                      learnCourse(item);
                    }}
                  >
                    学习
                  </Button>
                )}
                {[4, 5, 6].includes(item.commodityUserStatus) && (
                  <Button
                    type="primary"
                    disabled
                    style={{
                      background: "#e5e5e5",
                      border: "none",
                      color: "#ffff",
                    }}
                  >
                    购买
                  </Button>
                )}
                {/* 购买 */}
                {[2].includes(item.commodityUserStatus) && (
                  <Button
                    type="primary"
                    onClick={() => {
                      setShowOrderModal(true);
                      setPrice(item.salePrice);
                      setCommodityId(item.id);
                      setCommodityName(item.commodityName);
                    }}
                    danger
                  >
                    购买
                  </Button>
                )}
                {/* 获取 */}
                {[3].includes(item.commodityUserStatus) && (
                  <Button
                    type="primary"
                    onClick={() => {
                      learnCourse(item);
                    }}
                    danger
                    style={{
                      background: "#00BFBF",
                      border: "none",
                    }}
                  >
                    获取
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      })}
      {!classList && (
        <div className="no_class">
          <img src={no_class} alt="暂无数据" />
          <p>暂无数据</p>
        </div>
      )}
      <UserOrderConfirm
        showOrderModal={showOrderModal}
        setShowOrderModal={setShowOrderModal}
        commodityName={commodityName}
        totalPrice={price}
        commodityId={commodityId}
      />
    </div>
  );
});
export default PremiumCourse;
